import { enhancedApi as generatedBillingV2Api } from '@store/generated/billing-v2';

// Re-export all generated types for convenience
export type {
  ActivityFeedEvent,
  ActivityFeedGroup,
  BillingOverviewResponse,
  ChargeLineItem,
  ClaimsV2Response,
  ClaimV2Item,
  EncounterAdjustmentsSplit,
  EncounterClaimSummary,
  EncounterLedgerGroup,
  FlowHealthRow,
  LedgerEntryItem,
  PatientBillingQueueResponse,
  PatientBillingQueueSummary,
  PatientBillingStatus,
  PatientFinancialSummaryResponse,
  PatientResponsibilityBreakdown,
  PatientFinancialSummaryTotals,
  PatientInvoiceHistoryItem,
  PatientQueueItem,
  RemittancesV2Response,
  RemittanceV2Item,
  SegmentCount,
  SentInvoiceItem,
  SentInvoicesResponse,
  SentInvoicesSummary,
  SummaryStrip,
  WhatToDo,
  WorkGroup,
  WorkItem,
  WorkQueueResponse,
} from '@store/generated/billing-v2';

// Cache tag constants
const V2_TAGS = {
  OVERVIEW: 'BillingV2Overview',
  WORK: 'BillingV2Work',
  CLAIMS: 'BillingV2Claims',
  REMITTANCES: 'BillingV2Remittances',
  PATIENT_BILLING: 'BillingV2PatientBilling',
  PATIENT_DETAIL: 'BillingV2PatientDetail',
} as const;

// Enhance generated API with cache tags
const billingV2Api = generatedBillingV2Api.enhanceEndpoints({
  addTagTypes: Object.values(V2_TAGS),
  endpoints: {
    getV2ProviderBillingV2Overview: {
      providesTags: [V2_TAGS.OVERVIEW],
    },
    getV2ProviderBillingV2Work: {
      providesTags: [V2_TAGS.WORK],
    },
    getV2ProviderBillingV2Claims: {
      providesTags: [V2_TAGS.CLAIMS],
    },
    getV2ProviderBillingV2Remittances: {
      providesTags: [V2_TAGS.REMITTANCES],
    },
    getV2ProviderBillingV2PatientBillingQueue: {
      providesTags: [V2_TAGS.PATIENT_BILLING],
    },
    getV2ProviderBillingV2PatientBillingSent: {
      providesTags: [V2_TAGS.PATIENT_BILLING],
    },
    getV2ProviderBillingV2PatientsByPatientIdFinancialSummary: {
      providesTags: (_result, _err, arg) => [
        { type: V2_TAGS.PATIENT_DETAIL, id: arg.patientId },
      ],
    },
  },
});

// Export user-friendly hooks
export const {
  useGetV2ProviderBillingV2OverviewQuery: useOverviewQuery,
  useGetV2ProviderBillingV2WorkQuery: useWorkQueueQuery,
  useGetV2ProviderBillingV2ClaimsQuery: useClaimsV2Query,
  useGetV2ProviderBillingV2RemittancesQuery: useRemittancesV2Query,
  useGetV2ProviderBillingV2PatientBillingQueueQuery: usePatientBillingQueueQuery,
  useGetV2ProviderBillingV2PatientBillingSentQuery: usePatientBillingSentQuery,
  useGetV2ProviderBillingV2PatientsByPatientIdFinancialSummaryQuery: usePatientFinancialSummaryQuery,
} = billingV2Api;

export { billingV2Api, V2_TAGS };
